export default __webpack_public_path__ + "static/media/IconDesc_HyperTube_WallHole.64.0d1eae8b.png";